import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";

@Component({
    selector: 'app-plastic',
    templateUrl: 'app-plastic.html'
})

export class AppPlastic {

    @Input('plastic') public plastic: any;
    @Input('plastic-tint') public plasticTint: string;

    @Output('plastic-click') private _click: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util) {

    }

    ngOnInit() {


    }

    _emitClick(item) {

        this._click.emit(item);

    }

    classTint(): string {

        if (this.plasticTint == 'CorVerm') return 'tintverm';// util.plasticAlert(plastic, true) ? 'autenticar' : ''
        if (this.plasticTint == 'CorRoxa') return 'tintroxa';// util.plasticAlert(plastic, true) ? 'autenticar' : ''
        return '';

    }

}



// WEBPACK FOOTER //
// ./src/components/app-plastic/app-plastic.ts